import { Link } from 'react-router-dom';
import { tutorials } from '@/mocks/tutorials';

const hot = tutorials.slice(0, 3);

export default function HotTutorials() {
  return (
    <section className="w-full px-4 md:px-8 py-10 md:py-14">
      <div className="flex items-center justify-between mb-6 md:mb-8">
        <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950">热门摄影技巧</h2>
        <Link to="/tutorials" className="text-sm text-primary-600 hover:text-primary-700 cursor-pointer whitespace-nowrap">
          查看全部 <i className="ri-arrow-right-line"></i>
        </Link>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
        {hot.map((t) => (
          <Link
            key={t.id}
            to={`/tutorial/${t.id}`}
            className="group rounded-lg overflow-hidden bg-background-50 border border-background-200/70 hover:border-accent-300 transition-all cursor-pointer"
          >
            <div className="w-full h-40 overflow-hidden bg-background-100">
              <img src={t.cover} alt={t.title} title={t.title} className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500" />
            </div>
            <div className="p-4">
              <span className="inline-block px-2 py-0.5 text-xs rounded-full bg-accent-100 text-accent-800 mb-2">{t.level}</span>
              <h3 className="text-sm md:text-base font-medium text-foreground-900 line-clamp-2">{t.title}</h3>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}